module.exports = __webpack_public_path__ + "img/1542808923.7576de27.jpg";